import {
  CallsResponseDto,
  GenericGetFilterDto,
  PagedResponse,
  CaseRequestDto,
  CaseResponseDto,
  CaseHistoryResponseDto,
} from '@bandido/shared/dtos';
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions, useQuery } from 'react-query';
import { QueryKeys } from '../common/types';
import { client } from '../common/services';
import { OriginatedByChannel } from '@bandido/shared/types';

interface useGetCallsProps extends GenericGetFilterDto {
  onErrorCallback?: (_e: AxiosError) => void;
}

export const useGetCalls = (params?: useGetCallsProps | undefined) => {
  const { currentPage = 1, pageSize = 0, search, onErrorCallback } = params || {};
  return useQuery({
    queryKey: [QueryKeys.getCalls, currentPage, pageSize, search],
    queryFn: async (): Promise<PagedResponse<CallsResponseDto> | undefined> => {
      try {
        const result: AxiosResponse<PagedResponse<CallsResponseDto>, any> = await client.get('calls', {
          params: {
            currentPage,
            pageSize,
            search,
          },
        });

        return result.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });
};

export const useAssignCallToCase = (
  callId: CallsResponseDto['id'],
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<CaseHistoryResponseDto, any>,
          unknown,
          { caseId: CaseResponseDto['id'] },
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => client.post(`case/${data.caseId}/calls/${callId}`), options);

export const useCreateCaseForCall = (
  id: CallsResponseDto['id'],
  options?:
    | Omit<UseMutationOptions<AxiosResponse<number, any>, unknown, CaseRequestDto, unknown>, 'mutationFn'>
    | undefined,
) =>
  useMutation(
    (data) => client.post(`calls/${id}/case`, { ...data, originatedByChannel: OriginatedByChannel.CALL }),
    options,
  );
